import api from 'services/api';

/* The SeamVisionlineDoorsProps type represents the properties of a Seam Visionline Door. The properties are: */
export type SeamVisionlineDoorsProps = {
  acsEntranceId: string;
  displayName: string;
  profileType: string;
};

/* The SeamVisionlinePhoneProps type represents the properties of a Phone that gets registered from the mobile app.
The properties are: */
export type SeamVisionlinePhoneProps = {
  deviceId: string;
  deviceType: string;
};

/* The function `findAllVisionlineDoors` is an asynchronous function that makes a GET request to the `/apiv1/doors/visionline/` endpoint and returns 
all the Visionline Doors data from the response. */
const findAllVisionlineDoors = async (acs_system_id: string | undefined) => {
  const response = await api.get<SeamVisionlineDoorsProps[]>(
    `/apiv1/doors/visionline/${acs_system_id}/`
  );
  return response?.data;
};

/* The function `findAllOccupantPhones` is an asynchronous function that makes a GET request to the `/apiv1/phones/${occupant_uuid}/` endpoint and returns
all the registered phones data from the response. */
const findAllOccupantPhones = async (occupant_uuid: string | undefined) => {
  const response = await api.get<SeamVisionlinePhoneProps[]>(`/apiv1/phones/${occupant_uuid}/`);
  return response?.data;
};

const SeamAssaVisionlineService = {
  findAllVisionlineDoors,
  findAllOccupantPhones
};

export default SeamAssaVisionlineService;
